import React, { useContext } from 'react';
import { FaArrowRight, FaShoppingBag } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { BasketContext } from '../contexts/BasketContext';

function FrontPageBasket() {
    const { itemCount, total } = useContext(BasketContext);

    if (!itemCount) return null;

    return (
        <Link className="basket-dock" to="/checkout">
            <FaShoppingBag aria-hidden="true" />
            <span><b>{itemCount} {itemCount === 1 ? 'item' : 'items'}</b> in your basket</span>
            <strong>R{total.toFixed(2)}</strong>
            <FaArrowRight aria-hidden="true" />
        </Link>
    );
}

export default FrontPageBasket;
